module.exports = __webpack_public_path__ + "img/aplicación_de_repello.1c517be9.png";